var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92496 9.12594C2.08683 8.29324 1.66734 7.20187 1.66651 6.11051C1.66567 5.01581 2.08515 3.92111 2.92496 3.08506C4.60205 1.41631 7.32199 1.41631 8.99993 3.08506C10.677 1.41631 13.397 1.41631 15.0749 3.08506C15.9659 3.97117 16.3837 5.14931 16.3283 6.30909C16.2788 7.3337 15.861 8.3433 15.0749 9.12594L8.99993 15.1668L2.92496 9.12594Z",
    stroke: "#006FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.caae0c2ea22089c886c31f264fd76c92.svg";
export { ForwardRef as ReactComponent };